import { render, staticRenderFns } from "./Resourcedetails.vue?vue&type=template&id=0543e1e8"
import script from "./Resourcedetails.vue?vue&type=script&lang=js"
export * from "./Resourcedetails.vue?vue&type=script&lang=js"
import style0 from "./Resourcedetails.vue?vue&type=style&index=0&id=0543e1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports